import { Card, CardContent } from "../ui/card";

export function PilotsStatsCards({ pilots }) {
  // Fix 2026-08-28: "Escalados" debe coincidir con /production (que ya excluye
  // is_demo desde el 27/08) — antes contaba también las 3 fichas demo (Alcobendas/
  // Valdemingómez/Barredora Sevilla), dando 7 en vez de 4.
  const realPilots = pilots.filter(p => !p.is_demo);
  const total = realPilots.length;
  const pending = realPilots.filter(p => p.decision === "pending").length;
  const extended = realPilots.filter(p => p.decision === "extend").length;
  const scaled = realPilots.filter(p => p.decision === "scale").length;
  const discarded = realPilots.filter(p => p.decision === "discard").length;

  const cards = [
    { label: "Total Pilotos", value: total, color: "" },
    { label: "Pendientes", value: pending, color: "text-amber-600" },
    { label: "Extendidos", value: extended, color: "text-blue-600" },
    { label: "Escalados", value: scaled, color: "text-green-600" },
    { label: "Descartados", value: discarded, color: "text-red-600" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-testid="pilots-stats-cards">
      {cards.map(c => (
        <Card key={c.label} className="kpi-card" data-testid={`pilots-stat-card-${c.label.toLowerCase()}`}>
          <CardContent className="p-4">
            <p className="overline">{c.label}</p>
            <p className={`text-3xl font-bold mt-1 ${c.color}`}>{c.value}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
